import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

// @material-ui/icons
import Domain from '@material-ui/icons/Domain';
import Mood from '@material-ui/icons/Mood';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import Tutorial from 'components/Stepper/Tutorial';
import AnimatedTitle from 'components/Wrapper/AnimatedTitle';
import Button from 'components/CustomButtons/Button';
import FormHOC from 'hoc/FormHOC';
import config from 'config';
import SweetAlert from 'components/SweetModal/SweetAlert';

// style / context
import { Context } from 'context/Context';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';

class WaitingPage extends Component {
  state = { height: 0, emailsended: false };

  async componentDidMount() {
    !(await this.verifyToken()) && this.props.history.push('/auth');
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  resendConfirmationEmail() {
    const { user } = this.props.context.state;
    axios.post(`${config.API_URL}/public/auth/resend_confirmation_email`, { user }).then((res) => {
      console.log(res);
    });
    this.setState({ emailsended: true });
  }

  verifyToken = async () => {
    const localToken = this.props.context.state
      ? JSON.stringify(this.props.context.state.user.token)
      : this.props.location.state
      ? JSON.stringify(this.props.location.state.user.token)
      : localStorage.getItem('token');

    if (localToken && localToken !== 'undefined') {
      const token = JSON.parse(localToken);
      localStorage.setItem('token', localToken);
      return await axios
        .post(`${config.API_URL}/public/auth/verify_token`, { token })
        .then((res) => {
          this.props.context.updateUser(res.data.user);
          return true;
        })
        .catch(() => false);
    }
    return false;
  };

  updateWindowDimensions = () => {
    this.setState({ height: window.innerHeight });
  };

  render() {
    const {
      classes,
      context: {
        state: { user },
      },
    } = this.props;
    const { height } = this.state;

    const EmailSendedAlert = this.state.emailsended && (
      <SweetAlert
        success
        title='Email envoyé avec succés !'
        onConfirm={() => this.setState({ emailsended: false })}
        confirmBtnText='Ok'
        text='Un email vous a été envoyé.'
      />
    );

    let type = user && user.account.type ? user.account.type : 'null';
    const showTutorial = ['hr', 'student', 'pro', 'association', 'college'].includes(type);
    let color;
    let icon;
    switch (type) {
      case 'hr':
        color = 'yellow';
        icon = Domain;
        break;
      case 'student':
        color = 'red';
        icon = Mood;
        break;
      case 'pro':
        color = 'purple';
        type = 'not_active_pro';
        icon = Domain;
        break;
      case 'association':
        color = 'black';
        type = 'not_active_association';
        icon = Domain;
        break;
      case 'college':
        color = 'purple';
        type = 'not_active_college';
        icon = Domain;
        break;
      default:
        color = 'red';
        icon = Mood;
    }

    const content = (
      <Fragment>
        {height > 800 && <AnimatedTitle title='bienvenue' />}
        {showTutorial && <Tutorial type={type} color={color} />}
        {type === 'not_active_pro' && (
          <Button color='primary' onClick={() => this.resendConfirmationEmail()}>
            Email non reçu
          </Button>
        )}
        {type === 'student' && (
          <NavLink props={this.props} to='/annonces'>
            Voir les Offres
          </NavLink>
        )}
      </Fragment>
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          {EmailSendedAlert}
          <GridContainer justifyContent='center'>
            <ItemGrid xs={12} sm={10} md={8} lg={6}>
              <form>
                <IconCard icon={icon} iconColor={color} title='Bienvenue' content={content} footerAlign='center' />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

WaitingPage.propTypes = {
  classes: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
};

const WrappedComponent = FormHOC(WaitingPage);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
